import Icon from "@mui/material/Icon";

const FETE = ["super_admin", "admin_fete"];
const OUMRAH = ["super_admin", "admin_oumrah"];
const SACRIFICES_ADMIN = ["super_admin", "admin_sacrifices"];
const SACRIFICES_ALL = ["super_admin", "admin_sacrifices", "directeur", "delegue_sacrifices"];
const SACRIFICES_DIRECTEUR = ["directeur"];

const routes = [
  // ===================== FÊTE =====================
  { type: "title", title: "Fête", key: "titre-fete", roles: FETE },
  {
    type: "collapse", name: "Dashboard", key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard", component: null, roles: FETE,
  },
  {
    type: "collapse", name: "Réservations", key: "reservations",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/reservations", component: null, roles: FETE,
  },
  {
    type: "collapse", name: "Groupes", key: "groupes",
    icon: <Icon fontSize="small">music_note</Icon>,
    route: "/groupes", component: null, roles: FETE,
  },
  {
    type: "collapse", name: "Calendrier", key: "calendrier",
    icon: <Icon fontSize="small">calendar_month</Icon>,
    route: "/calendrier", component: null, roles: FETE,
  },
  {
    type: "collapse", name: "Éditions", key: "editions",
    icon: <Icon fontSize="small">calendar_today</Icon>,
    route: "/editions", component: null, roles: FETE,
  },
  {
    type: "collapse", name: "Retours de fêtes", key: "feedbacks",
    icon: <Icon fontSize="small">rate_review</Icon>,
    route: "/feedbacks", roles: FETE,
  },

  // ===================== OUMRAH =====================
  { type: "divider", key: "div-oumrah", roles: OUMRAH },
  { type: "title", title: "Oumrah", key: "titre-oumrah", roles: OUMRAH },
  {
    type: "collapse", name: "Tableau de bord", key: "oumrah-dashboard",
    icon: <Icon fontSize="small">insights</Icon>,
    route: "/oumrah/dashboard", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Sessions", key: "oumrah-sessions",
    icon: <Icon fontSize="small">flight_takeoff</Icon>,
    route: "/oumrah/sessions", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Inscriptions", key: "oumrah-inscriptions",
    icon: <Icon fontSize="small">how_to_reg</Icon>,
    route: "/oumrah/inscriptions", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Simulateur", key: "oumrah-simulateur",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: "/oumrah/simulateur", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Modèles de messages", key: "oumrah-modeles",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/oumrah/modeles", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Documents requis", key: "oumrah-documents-types",
    icon: <Icon fontSize="small">fact_check</Icon>,
    route: "/oumrah/documents-types", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Hébergement", key: "oumrah-hebergement",
    icon: <Icon fontSize="small">hotel</Icon>,
    route: "/oumrah/hebergement", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Départs", key: "oumrah-departs",
    icon: <Icon fontSize="small">flight_takeoff</Icon>,
    route: "/oumrah/departs", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Accompagnateurs", key: "oumrah-accompagnateurs",
    icon: <Icon fontSize="small">badge</Icon>,
    route: "/oumrah/accompagnateurs", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Bilan financier", key: "oumrah-bilan",
    icon: <Icon fontSize="small">euro</Icon>,
    route: "/oumrah/bilan", component: null, roles: OUMRAH,
  },
  {
    type: "collapse", name: "Récap paiement", key: "oumrah-recap",
    icon: <Icon fontSize="small">summarize</Icon>,
    route: "/oumrah/recap", component: null, roles: OUMRAH,
  },

  // ===================== SACRIFICES (ADMIN) =====================
  { type: "divider", key: "div-sacrifices-admin", roles: SACRIFICES_ADMIN },
  { type: "title", title: "Sacrifices", key: "titre-sacrifices-admin", roles: SACRIFICES_ADMIN },
  {
    type: "collapse", name: "Dashboard", key: "sacrifices-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/sacrifices-dashboard", component: null, roles: ["super_admin", "admin_sacrifices"],
  },
  {
    type: "collapse", name: "Sessions", key: "sacrifice-sessions",
    icon: <Icon fontSize="small">event_available</Icon>,
    route: "/sacrifice-sessions", component: null, roles: SACRIFICES_ADMIN,
  },
  {
    type: "collapse", name: "Toutes les demandes", key: "sacrifices-admin",
    icon: <Icon fontSize="small">list_alt</Icon>,
    route: "/sacrifices-admin", component: null, roles: SACRIFICES_ADMIN,
  },

  // ===================== DIRECTEUR =====================
  { type: "divider", key: "div-dir-fete", roles: ["directeur"] },
  { type: "title", title: "Fête", key: "titre-dir-fete", roles: ["directeur"] },
  {
    type: "collapse", name: "Mes Réservations", key: "mes-reservations",
    icon: <Icon fontSize="small">event_note</Icon>,
    route: "/mes-reservations", component: null, roles: ["directeur"],
  },
  { type: "title", title: "Oumrah", key: "titre-dir-oumrah", roles: ["directeur"] },
  {
    type: "collapse", name: "Mes Oumrah", key: "oumrah-directeur",
    icon: <Icon fontSize="small">flight</Icon>,
    route: "/oumrah/mes-inscriptions", component: null, roles: ["directeur"],
  },
  {
    type: "collapse", name: "Récap paiement", key: "oumrah-recap-dir",
    icon: <Icon fontSize="small">summarize</Icon>,
    route: "/oumrah/recap", component: null, roles: ["directeur"],
  },

  // ===================== SACRIFICES (DIRECTEUR / DÉLÉGUÉ) =====================
  { type: "title", title: "Sacrifices", key: "titre-sacrifices", roles: ["directeur", "delegue_sacrifices"] },
  {
    type: "collapse", name: "Mes sacrifices", key: "mes-sacrifices",
    icon: <Icon fontSize="small">volunteer_activism</Icon>,
    route: "/mes-sacrifices", component: null, roles: SACRIFICES_ALL,
  },
  {
    type: "collapse", name: "Mes délégués", key: "mes-delegues",
    icon: <Icon fontSize="small">group_add</Icon>,
    route: "/mes-delegues", component: null, roles: SACRIFICES_DIRECTEUR,
  },

  // ===================== ADMINISTRATION =====================
  { type: "divider", key: "div-admin", roles: ["super_admin"] },
  { type: "title", title: "Administration", key: "titre-admin", roles: ["super_admin"] },
  {
    type: "collapse", name: "Invitations", key: "invitations",
    icon: <Icon fontSize="small">mail</Icon>,
    route: "/invitations", roles: FETE,
  },
  {
    type: "collapse", name: "Lien inscription", key: "inscription-admin",
    icon: <Icon fontSize="small">link</Icon>,
    route: "/inscription-admin", roles: FETE,
  },
  {
    type: "collapse", name: "Utilisateurs", key: "utilisateurs",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/utilisateurs", component: null, roles: ["super_admin"],
  },
  { type: "divider", key: "div-profil" },
  {
    type: "collapse", name: "Mon profil", key: "profil",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/profil", component: null, roles: [...FETE, ...OUMRAH, "directeur", "admin_sacrifices", "delegue_sacrifices"],
  },
];

export default routes;
